import React from "react";
import { styled } from "@mui/material/styles";
import ErrorRounded from "@mui/icons-material/ErrorRounded";

const FlashingErrorIcon = styled(ErrorRounded)({
  color: "red",
  cursor: "pointer",
});

const FlashErrorIcon = ({ onClick }: { onClick: () => void }) => {
  return <FlashingErrorIcon onClick={onClick} className="error-icon" />;
};

export default FlashErrorIcon;
